import React from 'react';
import { FileSpreadsheet } from 'lucide-react';
import { formatDate as fmtDateUtil } from '../../utils/dateUtils';
import { LoadingState, DonutChart, BarGraph, ReportTable, fmt } from './ReportHelpers';

const fmtDate = (d) => fmtDateUtil(d);

export function JobsTab({ data, loading, onExport }) {
  if (loading) return <LoadingState />;
  if (!data) return null;
  const handleExport = () => {
    const headers = ['Job No.', 'Date', 'Client', 'Address', 'Status', 'Assignees'];
    const rows = data.items.map(r => [r.job_number, r.date, r.client_name, r.address, r.status, r.assignees]);
    onExport('Job Report', headers, rows, null);
  };
  return (
    <div className="space-y-4" data-testid="jobs-tab">
      <div className="flex justify-end print:hidden">
        <button onClick={handleExport} className="flex items-center gap-1.5 px-3 py-1.5 bg-green-600 text-white rounded text-sm hover:bg-green-700" data-testid="export-jobs-excel">
          <FileSpreadsheet size={14} /> Export Excel
        </button>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        <DonutChart data={data.by_status} title="Job Status Distribution" />
        <BarGraph data={data.by_status} title="Jobs by Status" />
      </div>
      <ReportTable
        headers={['Job No.', 'Date', 'Client', 'Address', 'Status', 'Assignees']}
        rows={data.items.map(r => [r.job_number, fmtDate(r.date), r.client_name, r.address, r.status, r.assignees])}
        testId="jobs-table"
      />
    </div>
  );
}
